import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTradingViewLine: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconTradingViewLine"><Path fillRule="evenodd" clipRule="evenodd" d="M22.842 7.21158L14.1266 18.3716L6.91781 11.3386L2.31437 16.5783L1.1875 15.5883L6.83406 9.16129L13.9753 16.1283L21.6598 6.28833L22.842 7.21158Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTradingViewLine;
